import { RootState } from '../store'

const getPageName = (state: RootState) => state.pageMetaData.data.pageName

export const PageMetaDataSelector = {
  getPageName,
}
